// extracted by mini-css-extract-plugin
export default {"mainImage":"yR2RgIvUwzwyIBzXTStX","header":"PYwRPplvImDiNw9rSbW6","subtext":"k_k6BN6qzcTVM0ngJ_O0"};